import Icon from '@components/Icon'
import Button from '@components/Button'
import CircleLoader from '@components/CircleLoader'

const ActivationView = ({ isLoading, error, onClick }) => (
    <div className="container text-center my-5">
        <div className="row row justify-content-center">
            <div className="col-md-5">
                {isLoading ? (
                    <>
                        <CircleLoader className="mb-5 mx-auto" />
                        <h2 className="mb-5">
                            <T>activation.loading</T>
                        </h2>
                    </>
                ) : error ? (
                    <>
                        <Icon type="restriction" size="xxxl" className="mb-4" />
                        <h2 className="mb-5">
                            <T>activation.error</T>
                        </h2>
                        <p className="mb-5">
                            <strong>{error}</strong>
                        </p>
                    </>
                ) : (
                    <>
                        <Icon type="success" size="xxxl" className="mb-4" />
                        <h2 className="mb-5">
                            <T>activation.header</T>
                        </h2>
                        <p className="mb-5">
                            <strong>
                                <T>activation.description</T>
                            </strong>
                        </p>
                    </>
                )}
            </div>
        </div>
        {!isLoading && !error && (
            <div className="row justify-content-center">
                <div className="col-md-3">
                    <Button size="large" block onClick={onClick} className="mb-3">
                        <T>auth.login.btn.label</T>
                    </Button>
                </div>
            </div>
        )}
    </div>
)

export default ActivationView
